// ADDED
import { useState, useCallback, useEffect } from "react";
import clinicRequirementsService from "../services/clinicRequirementsService";
import { SetAuditTrail, SetAuditTrailBulk } from "../../components/Reports/AuditTrailReportEmployeeSetup";
import { useGeneralMessage } from "../../common/APICommon";

export const useClinicRequirements = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const fetchRequirements = useCallback(async () => {
    setLoading(true);
    try {
      const res = await clinicRequirementsService.getAll();
      const responseData = res.data || [];
      setData(responseData);
      setFilterData(responseData);
    } catch (err) {
      console.error("Failed to fetch clinic requirements", err);
      showGeneralMessage("Failed to load clinic requirements", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  useEffect(() => {
    fetchRequirements();
  }, [fetchRequirements]);

  const handleAction = async (actionFn, auditData, ...args) => {
    setLoading(true);
    try {
      const res = await actionFn(...args);
      if (Array.isArray(auditData)) {
        await SetAuditTrailBulk({ data: auditData });
      } else if (auditData) {
        await SetAuditTrail(auditData);
      }
      showGeneralMessage(res.data?.message || "Action successful", true);
      await fetchRequirements();
      return { success: true, data: res.data };
    } catch (err) {
      const errorMsg = err.response?.data?.message || "An error occurred";
      showGeneralMessage(errorMsg, false);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const searchData = (value) => {
    if (!value) {
      setData(filterData);
      return;
    }
    const lower = value.toLowerCase();
    setData(filterData.filter(f =>
      f.description?.toLowerCase().includes(lower) ||
      f.id?.toString().includes(lower)
    ));
  };

  return {
    loading,
    data,
    showMessage,
    message,
    isSuccess,
    searchData,
    createRequirement: (p, audit) => handleAction(clinicRequirementsService.create, audit, p),
    updateRequirement: (id, p, audit) => handleAction(clinicRequirementsService.update, audit, id, p),
    deleteRequirement: (id) => handleAction(clinicRequirementsService.delete, null, id),
    refresh: fetchRequirements
  };
};